var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 256C384 309 341 352 288 352C234.1 352 192 309 192 256C192 202.1 234.1 160 288 160C341 160 384 202.1 384 256zM288 192C252.7 192 224 220.7 224 256C224 291.3 252.7 320 288 320C323.3 320 352 291.3 352 256C352 220.7 323.3 192 288 192zM0 128C0 92.65 28.65 64 64 64H512C547.3 64 576 92.65 576 128V384C576 419.3 547.3 448 512 448H64C28.65 448 0 419.3 0 384V128zM544 160V128C544 110.3 529.7 96 512 96H480C480 131.3 508.7 160 544 160zM448 96H128C128 149 85.02 192 32 192V320C85.02 320 128 362.1 128 416H448C448 362.1 490.1 320 544 320V192C490.1 192 448 149 448 96zM64 416H96C96 380.7 67.35 352 32 352V384C32 401.7 46.33 416 64 416zM544 352C508.7 352 480 380.7 480 416H512C529.7 416 544 401.7 544 384V352zM32 128V160C67.35 160 96 131.3 96 96H64C46.33 96 32 110.3 32 128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBill);
export default __webpack_public_path__ + "static/media/money-bill.b42c40fe9d5c9611c174e897b221e651.svg";
export { ForwardRef as ReactComponent };